import { render, staticRenderFns } from "./FieldsQuestion.vue?vue&type=template&id=72bbaedd&scoped=true"
import script from "./FieldsQuestion.vue?vue&type=script&lang=js"
export * from "./FieldsQuestion.vue?vue&type=script&lang=js"
import style0 from "./FieldsQuestion.vue?vue&type=style&index=0&id=72bbaedd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bbaedd",
  null
  
)

export default component.exports